"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _UserMenu = require("./UserMenu");

var _withTheme = require("../../wrappers/with-theme");

var _withAuth = _interopRequireDefault(require("../../wrappers/with-auth"));

var _lodash = _interopRequireDefault(require("lodash.get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _withAuth["default"])(function (_ref) {
  var title = _ref.title,
      _ref$shadowed = _ref.shadowed,
      shadowed = _ref$shadowed === void 0 ? false : _ref$shadowed,
      user = _ref.user,
      children = _ref.children;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full flex items-center px-8 ".concat(theme.headerBg),
    style: shadowed ? {
      boxShadow: "0px 6px 3px -3px rgba(0, 0, 0, 0.25)"
    } : null
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-3xl font-bold h-16 flex items-center"
  }, typeof title === "function" ? /*#__PURE__*/_react["default"].createElement(title) : title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-0 flex items-center"
  }, children, !user ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-8"
  }, /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenu, null, /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenuItem, {
    to: "/auth/profile"
  }, "Profile"), (0, _lodash["default"])(user, "authLevel", -1) < 5 ? null : /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenuItem, {
    to: "/auth/project-management"
  }, "Project Management"), /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenuSeparator, null), /*#__PURE__*/_react["default"].createElement(_UserMenu.UserMenuItem, {
    to: "/auth/logout"
  }, "Logout")))));
});

exports["default"] = _default;